<template>
<v-row style="max-width: 600px; margin: 0 auto;" >
        
        <v-col id="base" md="12" style="height: 100%; position: relative; display: flex; flex-direction: column; " class="mt-0 pt-0" >
            <!-- Header -->
            <v-row justify="center" align="center" :style="{'background-color': $store.state.colors.primary}">
                <v-img max-width="230px" src="@/assets/resources/yoomi/yoomy-blanco.png"></v-img>
            </v-row>
            <v-row justify="center" align="center" class="RestoRegular" style="color: #424242" :style="{ 'background-color': $store.state.colors.accent }">
                <v-col class="ml-8 mt-2 pt-1">
                    <v-row >
                        Bienvenid@
                    </v-row>
                </v-col>
            </v-row>
            <v-row style="height: 100%;" >
                <v-col >
                    <v-text-field 
                    v-model="user" 
                    label="Correo"  
                    @keyup.enter="inSubmit()"
                    outlined 
                    class="mt-0 mb-0"
                    ></v-text-field>
                    <v-text-field 
                    label="Contraseña" 
                    outlined 
                    class="mt-0 mb-0"
                    @keyup.enter="inSubmit()"
                    v-model="password"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[rules.required, rules.min]"
                    :type="showPassword ? 'text' : 'password'"
                    name="input-10-1"
                    counter
                    @click:append="showPassword = !showPassword"
                    ></v-text-field>
                    <v-row justify="center" class="mt-0 mb-0">
                        <v-btn :loading="loading" @click="inSubmit()" class="text-left buttonLower" :color="$store.state.colors.primary" dark x-large style="width: 90%; height: 55px; margin: 15px; ">
                            <span style="float: left; padding-left:0px;">Entrar</span>
                            <v-spacer></v-spacer>
                            <v-img max-width="20px" src="@/assets/resources/yoomi/arrow_white.png"></v-img>
                        </v-btn>
                    </v-row>
                    <v-row justify="end" class="pr-6">
                        <a @click="recoverPass()" style="color: black; background-color: transparent">¿Olvidaste tu contraseña?</a>
                    </v-row>
                    <v-row justify="center" align="center" style="width: 100%; position: absolute; left: 0px; bottom: 0px; margin: 0 auto;" :style="{'background-color':$store.state.colors.primary}" class="pt-0">

                    </v-row>
                <!-- <v-snackbar v-model="alert" :top="true" color="error">
                    {{alertMessage}}
                </v-snackbar>
                <v-snackbar v-model="alert2" :top="true" color="info">
                    {{alertMessage2}}
                </v-snackbar>
                <v-snackbar v-model="alert3" :top="true" color="error">
                    {{alertMessage3}}
                </v-snackbar>
                <v-snackbar v-model="alert4" :top="true" color="error">
                    {{alertMessage4}}
                </v-snackbar> -->
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import axios from 'axios';

    export default {
        name: 'loginDeliveryMan',
        data(){
            return {
                loading: false,
                alert: false,
                alert2: false,
                alert3: false,
                alert4: false,
                alertMessage: 'Usuario y/o Contraseña Incorrectas, Intenta de nuevo',
                alertMessage2: 'Correo Enviado',
                alertMessage3: 'Repartidor No Registrado',
                alertMessage4: 'Completa todos los campos',
                alertColor: 'error',
                password: '',
                confirmPassword: '',
                showPassword: false,
                showConfirm: false,
                rules: {
                    min: v => v ? (v.length >= 4 || "Mínimo 4 caractéres") : true,
                    equals: c => c ? (c == this.password || 'Las contraseñas no coinciden') : true,
                    required: true
                },
                user: null
            }
        },
        methods:
        {
            async inSubmit ()
            {
                this.loading = true;
                if(this.user==''||this.password=='')
                {
                    this.loading = false;
                    this.$store.state.alertState = true;
                    this.$store.state.alertMessage = this.alertMessage4;
                    this.$store.state.alertColor = "error";
                    setTimeout(() => {
                    this.$store.state.alertState = false;
                    }, 4000);
                    return 0;                 
                }
                const formData = 
                {
                    user: this.user,
                    pass: this.password
                }
                console.log(formData);
                    var username = 'swyt1';
                    var password = 'r3stoDirec0.y';
                    var basicAuth = 'Basic ' + btoa(username + ':' + password);
                // console.log(basicAuth);
                    const headers = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
                this.$store.dispatch('loginDelivery',{ 
                    user: this.user,
                    pass: this.password,
                    headers: headers
                }).then( res => {
                    this.loading = false;
                    if(res.data.error == 'Error en datos de login')
                    {
                        this.$store.state.alertState = true;
                        this.$store.state.alertMessage = this.alertMessage;
                        this.$store.state.alertColor = "error";
                        setTimeout(() => {
                        this.$store.state.alertState = false;
                        }, 4000);                     
                     }
                    else
                    {
                        this.$router.push({ name: 'orders_delivery_man'});
                        this.$store.state.validationDelivery=true;
                    }    
                });
                    
            },
            recoverPass()
            {
                if(!this.checkDataEmail)
                {
                    var username = 'swyt1';
                    var password = 'r3stoDirec0.y';
                    var basicAuth = 'Basic ' + btoa(username + ':' + password);
                    const headers = { 'Content-Type': 'application/json', 'Authorization': basicAuth}
                    console.log(this.user)
                    axios.post('/recuperar', {correo: this.user}, {headers: headers})
                        .then(res =>{
                            console.log(res);
                            console.log(res.data.mensaje)
                            if(res.data.mensaje == 'Correo enviado')
                                {
                                    this.$store.state.alertState = true;
                                    this.$store.state.alertMessage = this.alertMessage2;
                                    this.$store.state.alertColor = "info";
                                    setTimeout(() => {
                                    this.$store.state.alertState = false;
                                    }, 4000);
                                }
                                else
                                {
                                    this.$store.state.alertState = true;
                                    this.$store.state.alertMessage = this.alertMessage3;
                                    this.$store.state.alertColor = "error";
                                    setTimeout(() => {
                                    this.$store.state.alertState = false;
                                    }, 4000);
                                }
                        })
                        .catch(error => {
                            console.log(error)}
                        );
                    } 
            },

        },
        created() {
            this.$store.state.logo = false;
        }
    }
</script>
<style>
.disable-events 
{
    pointer-events: none;
}
.a:hover 
{ 
  background-color: white;
} 
.disable-events 
{
    pointer-events: none
}  
</style>